<template>
  <div id="app">

    <header id="renew2_header"
      v-if="$route.name != 'okinaviPage' && $route.name != 'shogaiPage' && $site.appFlag != 'b' && !isOnlyPreview">
      <div class="menu_block renew2_wrapper">

        <div style="display: flex;align-items: flex-end;font-weight: bold;color: #004D40;">
          <h1 class="h1"><a href="/"><img src="/static/renew2_img/yagish_logo_20230522.png"
                alt="yagishブラウザでつくる履歴書・職務経歴書"></a></h1>
          <p style="font-size: 0.8rem;line-height: 1.2;"
            v-if="headerTitle == 0 && $route.params.formatId != 'rirekisho_esf_challenged'">Webで簡単<br>最短3分で履歴書作成</p>
          <p style="font-size: 0.8rem;line-height: 1.2;"
            v-else-if="headerTitle == 1 && $route.params.formatId != 'rirekisho_esf_challenged'">無料で<br>ダウンロードもできる</p>
          <p style="font-size: 0.8rem;line-height: 1.2;"
            v-else-if="headerTitle == 2 && $route.params.formatId != 'rirekisho_esf_challenged'">80%の<br>大学生や新卒が利用</p>
          <p style="font-size: 0.8rem;line-height: 1.2;" v-else-if="false">国内700万人以上<br>が利用</p>
        </div>
        <h1 class="h1" v-if="false">
          <a href="/">
            <img src="/static/renew2_img/yagish_logo_20230522.png" alt="yagishブラウザでつくる履歴書・職務経歴書">
          </a>
        </h1>
        <div class="renew2_pc">
          <ul class="renew2_flex sub_menu">
            <li class="menu_list renew2_link_toggle" v-if="getMode != 'productionX'"><a
                href="https://resume.yagish.kr/">韓国語</a></li>
            <li class="menu_list renew2_link_toggle"><a href="https://www.yagish.jp/">運営会社</a></li>
            <li class="menu_list contact renew2_link_toggle"><a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform">お問い合わせ</a>
            </li>
          </ul>
          <ul class="renew2_flex menu" v-if="$route.params.formatId != 'rirekisho_esf_challenged'">
            <li class="menu_list"><a href="/">履歴書作成</a></li>
            <li v-if="false" class="menu_list"><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
            <li v-if="false" class="menu_list"><a href="/yagiofferhelp">ヤギオファー</a></li>
            <li class="menu_list" v-if="false"><a href="#">求人一覧</a></li>
            <li v-if="!$firebase.isAuthenticated" class="menu_list login"><a href="/login">ログイン</a></li>
            <li v-if="!$firebase.isAuthenticated" class="menu_list register"><a href="/mregister">会員登録</a></li>
            <li v-if="$firebase.isAuthenticated && !$globalVar.isYagiPrime" class="menu_list renew2_mypage"><a
                href="/mypage" class="on_mypage"><span v-if="$firebase.user.displayName">{{ $firebase.user.displayName
                  }} </span>[ {{
        $firebase.user.email }} ]<div id="email_for_googleads" style="display:none;">{{ $firebase.user.email }}
                </div> <span class="renew2_font_small">さん</span></a>
            </li>
            <li v-if="$firebase.isAuthenticated && $globalVar.isYagiPrime" class="menu_list renew2_mypage"><a
                href="/mypage/yagiprime" class="on_mypage"><span
                  style="position: absolute;display: inline-block;color: #fff;font-size: 0.5rem;font-weight: bold;background: #e3165c;border-radius: 50%;width: 16px;height: 16px;text-align: center;line-height: 2.1;top: -10px;left: -18px">{{
        csCount }}</span><span v-if="$firebase.user.displayName">{{
        $firebase.user.displayName
      }} </span>[ {{
          $firebase.user.email }} ]<div id="email_for_googleads" style="display:none;">{{ $firebase.user.email }}
                </div> <span class="renew2_font_small">さん</span></a>
            </li>
          </ul>
          <ul class="renew2_flex menu" v-else>
            <li v-if="$firebase.isAuthenticated" class="menu_list renew2_mypage"><a href="/mypage"
                class="on_mypage"><span v-if="$firebase.user.displayName">{{ $firebase.user.displayName }} </span>[ {{
        $firebase.user.email }} ]<div id="email_for_googleads" style="display:none;">{{ $firebase.user.email }}
                </div> <span class="renew2_font_small">さん</span></a></li><!--登録メールアドレス-->
          </ul>
        </div>
        <div class="renew2_sp">
          <ul v-if="!$firebase.isAuthenticated" class="renew2_flex renew2_sp_flex sp_loginbtn">
            <li class="sp_menu_list"><a href="/login">ログイン</a></li>
            <li class="sp_menu_list"><a href="/mregister">会員登録</a></li>
          </ul>
          <div v-if="$firebase.isAuthenticated && !$globalVar.isYagiPrime" class="renew2_mypage"><a href="/mypage"
              class="on_mypage"><span v-if="getName">{{ getName }} </span><span class="renew2_font_small">さん</span></a>
          </div>
          <div v-if="$firebase.isAuthenticated && $globalVar.isYagiPrime" class="renew2_mypage"><a
              href="/mypage/yagiprime" class="on_mypage"><span
                style="position: absolute;display: inline-block;color: #fff;font-size: 0.5rem;font-weight: bold;background: #e3165c;border-radius: 50%;width: 16px;height: 16px;text-align: center;line-height: 2.1;top: -10px;left: -18px">{{
        csCount }}</span><span v-if="getName">{{ getName }} </span><span class="renew2_font_small">さん</span></a>
          </div>
        </div>
      </div>
    </header>


    <div v-if="getMode != 'production1' && false">
      <a href="https://www.yagish.jp/maintenance/%e7%b7%8a%e6%80%a5%e3%82%b7%e3%82%b9%e3%83%86%e3%83%a0%e3%83%a1%e3%83%b3%e3%83%86%e3%83%8a%e3%83%b3%e3%82%b9%e3%81%ae%e3%81%8a%e7%9f%a5%e3%82%89%e3%81%9b/"
        target="_blank"
        style="display: flex; background: #FFF620; align-items: center; justify-content: center; color:red;">
        緊急システムメンテナンスのお知らせ</a>
    </div>

    <router-view></router-view>

    <button type="button" class="el-button el-button--primary" @click="goBack" v-if="!isTopPage && $site.appFlag == 'b'"
      style="background: #fff;color: #e3165c;position: fixed;bottom: 30px;left: 10px;z-index: 90;"><!----><!----><span><i
          class="el-icon-d-arrow-left"></i>もどる</span></button>

    <footer id="renew2_footer" v-if="$site.appFlag != 'b' && !isOnlyPreview">
      <div class="renew2_footer">
        <div class="renew2_wrapper footer_block">
          <div class="renew2_flex link_block">
            <div class="link_block__list">
              <img src="/static/renew2_img/logo.svg" alt="ヤギッシュ">
              <p class="renew2_font_small">yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。</p>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform"
                class="contact_link renew2_link_toggle">お問い合わせ</a>
            </div><!--ロゴ-->
            <div class="link_block__container renew2_flex">
              <ul class="link_block__list margin">
                <li><a href="/">履歴書作成</a></li>
                <li v-if="false"><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
                <li><a href="#" v-if="false">求人一覧</a></li>
                <li v-if="false"><a href="/yagiofferhelp">ヤギオファー</a></li>
                <li><a href="/info">yagishの使い方</a></li>
              </ul><!--リンクリスト1-->
              <ul class="link_block__list">
                <li><a href="https://www.yagish.jp/" target="_blank">運営会社</a></li>
                <li><a href="https://www.yagish.jp/recruit/" target="_blank">yagish採用</a></li>
                <li><a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></li>
                <li><a href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a></li>
                <li><a href="/law" target="_blank">特定商取引法に基づく表示</a></li>
                <li><a href="/terms">利用規約</a></li>
                <li><a href="/help">よくある質問</a></li>
              </ul><!--リンクリスト2-->
              <!--<ul class="link_block__list">
                          <li><a href="">サイトマップ</a></li>
                      </ul>リンクリスト3-->
            </div>
          </div>
          <div class="service_block">
            <p class="service_block__title">サービス一覧</p>
            <div class="renew2_flex service_block__list">
              <ul class="service_block__item">
                <li><a href="/">履歴書</a></li>
                <li><a href="https://www.yagish.jp/service/daigakuyagish/" target="_blank">各大学専用履歴書</a></li>
                <li v-if="false"><a href="#" v-if="false">求人一覧</a></li>
                <li v-if="false"><a href="https://portal.yagish.jp/company/presidents-style/" target="_blank">社長の流儀</a>
                </li>
              </ul><!--リンクリスト1-->
              <ul class="service_block__item">
                <li v-if="false"><a href="/yagiofferhelp">ヤギオファー</a></li>
                <li><a href="/quickmailhelp">ヤギの宅配便</a></li>
                <li><a href="/quickemailhelp">ヤギのメール便</a></li>
                <li><a href="/fontservicehelp">フォントサービス</a></li>
                <li><a href="/yagiprimeinfo">ヤギプライム</a></li>
              </ul><!--リンクリスト2-->
              <!--<ul class="service_block__item">https://www.yagish.jp/service/daigakuyagish/
                        <li><a href="">退職代行</a></li>
                        <li><a href="">赤ペン人事部長</a></li>
                    </ul>リンクリスト3-->

              <ul class="service_block__item bnr_item"><!---->
                <li><a href="https://line.me/S/sticker/25186829" target="_blank"><img
                      src="/static/renew2_img/bnr_linestamp.png"></a></li>
              </ul>
              <ul class="service_block__item bnr_item"><!---->
                <li><a href="https://line.me/S/emoji/?id=6583aab3896d8c165266159e" target="_blank"><img
                      src="/static/renew2_img/bnr_lineemoji.png"></a></li>
              </ul>

            </div>
          </div>
        </div>
        <div v-if="getMode != 'productionX'" class="renew2_flex renew2_sp_flex" style="
              justify-content: center;
              margin-top: 10px;">
          <a href="" target="_blank" style="
              margin-right: 15px;
              color: #fff;
              font-weight: bold;" v-if="false">日本語</a>
          <a href="https://resume.yagish.kr/" target="_blank" style="
              color: #fff;
              font-weight: bold;">韓国語</a>
        </div>
        <p class="copyright">©2021-2024 Yagish Co., Ltd. All rights reserved.</p>
      </div>
    </footer>



    <account-dialog />
    <eprint-dialog />
    <adtop-dialog />
    <cocorowa-dialog />
    <newgrade-dialog />
    <tempdata-dialog />
    <sendmail-dialog />
    <medley-dialog />
    <jigen-dialog />
    <tryt-dialog />
    <systemshared-dialog />
    <mynavi-ms-dialog />
    <jaic-dialog />
    <roxx-dialog />
    <athlete-dialog />
    <baton-dialog />
    <parttime-dialog />
    <yagishcareer-dialog />
    <realive-dialog />
    <jobs919-dialog />
    <introduction-dialog />
    <all-preview-dialog />
    <miraiyu-dialog />
    <yagioffer-dialog />
    <etc-dialog />
    <joblist-dialog />
    <loginform-dialog />
    <kirara-dialog />
    <simple-dialog />
    <neocareer-dialog />
    <fontpayment-dialog />
    <yagiprimefontpayment-dialog />
    <yagish-dialog />
    <careerdraft-dialog />
    <carat-dialog />
    <reastage-dialog />
    <mynavi-dialog />
    <recruit_mc-dialog />
    <yagioffer-special-dialog />
    <asiro-dialog />
    <capla-dialog />
    <bridge-dialog />
    <dely-dialog />
    <cellpromote-dialog />
    <loginess-dialog />
    <agrinavi-dialog />
    <recree-dialog />
    <growtrail-dialog />
    <rozas-dialog />
    <hrcareer-dialog />
    <tunaguba-dialog />
    <workport-dialog />
    <krasys-dialog />
    <xmile-dialog />
    <pleiades-dialog />
    <peacekaigo-dialog />
    <hitotech-dialog />
    <techouse-dialog />
  </div>
</template>


<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>

<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>
<style lang="scss" scoped>
.service_block__list .bnr_item img {
  width: 234px;
  height: 75px;
}

@media screen and (max-width: 640px) {
  #renew2_footer .service_block__list .bnr_item {
    margin-right: 0;
    margin: 20px 0;
  }

  #renew2_footer .service_block__list .bnr_item img {
    width: 100%;
    height: auto;
  }
}
</style>
<script>
import EprintDialog from '@/components/EprintDialog'
import AdtopDialog from '@/components/AdtopDialog'
import SendMailDialog from '@/components/SendMailDialog'
import CocorowaDialog from '@/components/CocorowaDialog'
import NewGradeDialog from '@/components/NewGradeDialog'
import AccountDialog from '@/components/AccountDialog'
import TempDataDialog from '@/components/TempDataDialog'
import MedleyDialog from '@/components/MedleyDialog'
import JigenDialog from '@/components/JigenDialog'
import TrytDialog from '@/components/TrytDialog'
import MynaviMsDialog from '@/components/MynaviMsDialog'
import SystemSharedDialog from '@/components/SystemSharedDialog'
import JaicDialog from '@/components/JaicDialog'
import RoxxDialog from '@/components/RoxxDialog'
import BatonDialog from '@/components/BatonDialog'
import YagishCareerDialog from '@/components/YagishCareerDialog'
import AthleteDialog from '@/components/AthleteDialog'
import ParttimeDialog from '@/components/ParttimeDialog'
import Job919Dialog from '@/components/Job919Dialog'
import RealiveDialog from '@/components/RealiveDialog'
import IntroductionDialog from '@/components/IntroductionDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'
import MiraiyuDialog from '@/components/MiraiyuDialog'
import YagiOfferDialog from '@/components/YagiOfferDialog'
import EtcDialog from '@/components/EtcDialog'
import JoblistDialog from '@/components/JobListDialog'
import LoginFormDialog from '@/components/LoginFormDialog'
import KiraraDialog from '@/components/KiraraDialog'
import SimpleDialog from '@/components/SimpleDialog'
import NeocareerDialog from '@/components/NeocareerDialog'
import YagiprimeFontPaymentDialog from '@/components/YagiprimeFontPaymentDialog'
import FontPaymentDialog from '@/components/FontPaymentDialog'
import YagishDialog from '@/components/YagishDialog'
import CareerdraftDialog from '@/components/CareerdraftDialog'
import CaratDialog from '@/components/CaratDialog20240801'
import ReastageDialog from '@/components/ReastageDialog'
import MynaviDialog from '@/components/MynaviDialog'
import RecruitMcDialog from '@/components/RecruitMcDialog'
import YagiofferSpecialDialog from '@/components/YagiofferSpecialDialog'
import AsiroDialog from '@/components/AsiroDialog'
import CaplaDialog from '@/components/CaplaDialog'
import BridgeDialog from '@/components/BridgeDialog'
import DelyDialog from '@/components/DelyDialog'
import CellpromoteDialog from '@/components/CellpromoteDialog'
import LoginessDialog from '@/components/LoginessDialog'
import AgrinaviDialog from '@/components/AgrinaviDialog'
import RecreeDialog from '@/components/RecreeDialog'
import GrowtrailDialog from '@/components/GrowtrailDialog'
import RozasDialog from '@/components/RozasDialog'
import HrcareerDialog from '@/components/HrcareerDialog'
import TunagubaDialog from '@/components/TunagubaDialog'
import WorkportDialog from '@/components/WorkportDialog'
import KrasysDialog from '@/components/KrasysDialog'
import XMileDialog from '@/components/XMileDialog'
import PleiadesDialog from '@/components/PleiadesDialog'
import PeacekaigoDialog from '@/components/PeacekaigoDialog'
import HitotechDialog from '@/components/HitotechDialog'
import TechouseDialog from '@/components/TechouseDialog'

export default {
  props: {
    isLight: {
      type: Boolean
    }
  },
  components: {
    'eprint-dialog': EprintDialog,
    'account-dialog': AccountDialog,
    'adtop-dialog': AdtopDialog,
    'cocorowa-dialog': CocorowaDialog,
    'newgrade-dialog': NewGradeDialog,
    'tempdata-dialog': TempDataDialog,
    'sendmail-dialog': SendMailDialog,
    'medley-dialog': MedleyDialog,
    'jigen-dialog': JigenDialog,
    'roxx-dialog': RoxxDialog,
    'tryt-dialog': TrytDialog,
    'mynavi-ms-dialog': MynaviMsDialog,
    'systemshared-dialog': SystemSharedDialog,
    'jaic-dialog': JaicDialog,
    'baton-dialog': BatonDialog,
    'parttime-dialog': ParttimeDialog,
    'jobs919-dialog': Job919Dialog,
    'yagishcareer-dialog': YagishCareerDialog,
    'athlete-dialog': AthleteDialog,
    'realive-dialog': RealiveDialog,
    'miraiyu-dialog': MiraiyuDialog,
    'introduction-dialog': IntroductionDialog,
    'all-preview-dialog': AllPreviewDialog,
    'yagioffer-dialog': YagiOfferDialog,
    'etc-dialog': EtcDialog,
    'joblist-dialog': JoblistDialog,
    'loginform-dialog': LoginFormDialog,
    'kirara-dialog': KiraraDialog,
    'simple-dialog': SimpleDialog,
    'neocareer-dialog': NeocareerDialog,
    'fontpayment-dialog': FontPaymentDialog,
    'yagiprimefontpayment-dialog': YagiprimeFontPaymentDialog,
    'yagish-dialog': YagishDialog,
    'careerdraft-dialog': CareerdraftDialog,
    'carat-dialog': CaratDialog,
    'reastage-dialog': ReastageDialog,
    'mynavi-dialog': MynaviDialog,
    'recruit_mc-dialog': RecruitMcDialog,
    'yagioffer-special-dialog': YagiofferSpecialDialog,
    'asiro-dialog': AsiroDialog,
    'capla-dialog': CaplaDialog,
    'bridge-dialog': BridgeDialog,
    'dely-dialog': DelyDialog,
    'cellpromote-dialog': CellpromoteDialog,
    'loginess-dialog': LoginessDialog,
    'agrinavi-dialog': AgrinaviDialog,
    'recree-dialog': RecreeDialog,
    'growtrail-dialog': GrowtrailDialog,
    'rozas-dialog': RozasDialog,
    'hrcareer-dialog': HrcareerDialog,
    'tunaguba-dialog': TunagubaDialog,
    'workport-dialog': WorkportDialog,
    'krasys-dialog': KrasysDialog,
    'xmile-dialog': XMileDialog,
    'pleiades-dialog': PleiadesDialog,
    'peacekaigo-dialog': PeacekaigoDialog,
    'hitotech-dialog': HitotechDialog,
    'techouse-dialog': TechouseDialog
  },
  data: function () {
    return {
      headerTitle: 0,
      csCount: 0
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    checkMynabi: function () {
      if (this.$route.query.mynavi === '19xs#rrdfS234') {
        this.$yagi.isFromMynabi = 1
      }
    },
    authStateChanged: async function () {
      console.error(this.$firebase.user.uid)
      const app = this
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          if (response.data.is_subscribed) {
            const formData = new FormData()
            formData.append('uuid', app.$firebase.user.uid)

            app.$axios
              .post(app.$varuna.endPoints.subscriptionsMypage, formData, { timeout: 60000 })
              .then(function (response) {
                console.error(response.data)
                let _joblist = response.data.recommended_jobs

                for (let _key in _joblist) {
                  let _job = _joblist[_key]
                  if (!_job.read_date) {
                    app.csCount++
                    console.error(_job.read_date)

                  }

                }
              })
              .catch(function (error) {
              }).finally(function () {
                app.fullscreenLoading = false
              })
          }
        })
        .catch(function (error) {
        }).finally(function () {
        })
    }
  },
  computed: {
    getName: function () {
      if (this.$firebase.user.displayName) {
        return this.$firebase.user.displayName
      } else {
        if (this.$firebase.user.email) {
          return this.$firebase.user.email.split('@')[0]
        } else {
          return 'ヤギ'
        }
      }
    },
    logoBaseStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#fff'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#6bff38'
        }
      } else {
        return {
          fill: '#cc38ff'
        }
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    logoEyeStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#e91044'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#09bc6c'
        }
      } else {
        return {
          fill: '#fff'
        }
      }
    },
    isTopPage: function () {
      return (this.$route.name === 'top')
    },
    isOnlyPreview: function () {
      return (this.$route.name === 'previewOnly') || (this.$route.query.noheader === '1')
    },
    isMynabi: function () {
      this.checkMynabi()
      return (this.$yagi.isFromMynabi === 1)
    },
    isEditingFormat: function () {
      return (this.$route.name === 'formatEditCard')
    },
    needsFullScreen: function () {
      return (this.$route.name === 'formatPreview')
    },
    needsFooter: function () {
      if (this.$route.name === 'formatPreview' || this.$route.name === 'formatEditCard') {
        return false
      }
      return true
    }
  },
  created: function () {

    console.error(this.$route.fullPath)
    console.error(this.$route.params.formatId)
    const nowdate = new Date()
    let dayOfWeek = nowdate.getDay()
    this.headerTitle = nowdate.getDate() % 4
    const app = this
    this.headerTitle = 99

    const formData = new FormData()
    formData.append('app_flag', this.$site.appFlag)
    this.$axios
      .post(this.$varuna.endPoints.siteSetting, formData, { timeout: 60000 })
      .then(function (response) {
        console.error(response.data)
        console.error(response.data.in_app_payments)
        if (response.data.in_app_payments == 0) {
          tapp.$globalVar.in_app_paymens = false
        }
      })
      .catch(function (error) {
      }).finally(function () {
      })

  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
